import { inject, Injectable } from '@angular/core';
import {
  Configuration,
  FlowError as LibFlowError,
  FrontendApi,
  LoginFlow,
  RegistrationFlow as LibRegistrationFlow,
  Session as LibSession,
  SuccessfulNativeRegistration as LibSuccessfulNativeRegistration,
  UpdateRegistrationFlowBody as LibUpdateRegistrationFlowBody,
} from '@ory/client';
import { FlowError, FrontendService, RegistrationFlow, Session, UpdateRegistrationFlowBody } from '../../../apis/ory';
import { TitleService } from '../../../utils';
import moment from 'moment';
import { Observable, switchMap, tap } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class OryAuthService {
  private newOpenApiOryAPI = inject(FrontendService);
  private ui = inject(TitleService);

  getOryLoginFlow(_flowId: string): Promise<LoginFlow> {
    throw new Error('Method not implemented.');
  }
  private newRegistrationFlowId: string | null = null;
  private registrationFlowId: string | null = null;
  // private newRegistrationFlow: RegistrationFlow | null = null;
  private registrationFlow: LibRegistrationFlow | null = null;
  private oryFrontendApi = new FrontendApi(
    new Configuration({
      basePath: 'http://localhost:4433',
      baseOptions: {
        withCredentials: false,
        timeout: 10000,
      },
    }),
    '',
  );

  public createOryRegisterFlow$(): Observable<RegistrationFlow> {
    return this.newOpenApiOryAPI.createNativeRegistrationFlow().pipe(
      tap((flow: RegistrationFlow) => {
        this.newRegistrationFlowId = flow.id;
      }),
    );
  }
  public getOryRegisterFlow$(id: string | null = this.newRegistrationFlowId): Observable<RegistrationFlow> {
    if (!id) {
      return this.newOpenApiOryAPI.createNativeRegistrationFlow();
    }
    return this.newOpenApiOryAPI.getRegistrationFlow(id);
  }
  public createBrowserOryRegisterFlow$(): Observable<RegistrationFlow> {
    return this.newOpenApiOryAPI.createBrowserRegistrationFlow().pipe(
      tap((flow: RegistrationFlow) => {
        this.newRegistrationFlowId = flow.id;
      }),
    );
  }
  public getOryBrowserRegisterFlow$(id: string | null = this.newRegistrationFlowId): Observable<RegistrationFlow> {
    if (!id) {
      return this.newOpenApiOryAPI.createBrowserRegistrationFlow();
    }
    return this.newOpenApiOryAPI.getRegistrationFlow(id);
  }
  public submitOryRegistration$(body: UpdateRegistrationFlowBody, id: string | null = this.newRegistrationFlowId) {
    console.log('submitOryRegistration', id, body);
    if (!id) {
      return this.newOpenApiOryAPI
        .createNativeRegistrationFlow()
        .pipe(switchMap((value: RegistrationFlow) => this.newOpenApiOryAPI.updateRegistrationFlow(value.id, body)));
    } else {
      return this.newOpenApiOryAPI.updateRegistrationFlow(id, body);
    }
  }
  public getError$(error_id: string): Observable<FlowError> {
    return this.newOpenApiOryAPI.getFlowError(error_id);
  }
  public checkSession$(): Observable<Session> {
    return this.newOpenApiOryAPI.toSession();
  }

  public async createOryRegisterFlow(): Promise<LibRegistrationFlow> {
    if (this.registrationFlowId && moment().isBefore(this.registrationFlow?.expires_at)) {
      return await this.getOryRegisterFlow(this.registrationFlowId);
    } else {
      const flow = await this.oryFrontendApi
        .createBrowserRegistrationFlow({ organization: 'Rent-ME' })
        .then((res) => {
          console.log('RegistrationFlow', res);
          return res;
        })
        .catch((err: Error) => {
          console.log('RegistrationFlow', err);
          return err;
        });
      if (!(flow instanceof Error) && flow?.data && flow?.status < 400) {
        this.registrationFlow = flow.data;
        this.ui.loading.next(false);
        return flow.data;
      } else {
        this.ui.loading.next(false);
        throw new Error('Flow not found');
      }
    }
  }
  public async getOryRegisterFlow(id: string): Promise<LibRegistrationFlow> {
    console.log('GetOryRegisterFlow', id);
    if (!id || this.registrationFlow?.id !== id || moment().isBefore(this.registrationFlow?.expires_at)) {
      const createFlow = await this.createOryRegisterFlow();
      console.log('GetOryRegisterFlow-create', createFlow);
      return createFlow;
    } else {
      const flow = await this.oryFrontendApi.getRegistrationFlow({ id });
      if (flow.data && flow.status < 400) {
        this.ui.loading.next(false);
        return flow.data;
      } else {
        this.ui.loading.next(false);
        throw new Error('Flow not found');
      }
    }
  }
  // Returns `.data` rather than the whole AxiosResponse, matching getError just
  // below. Returning the response made the inferred type reach into
  // @ory/client's own nested axios, which is not nameable from here (TS2742).
  // `id` used to default to `this.registrationFlowId`, which nothing in the
  // service ever assigns, so the default could only ever be null.
  public async submitOryRegistration(
    body: LibUpdateRegistrationFlowBody,
    id: string,
  ): Promise<LibSuccessfulNativeRegistration> {
    console.log('SubmitOryRegistration', id, body);
    const registration = await this.oryFrontendApi.updateRegistrationFlow({
      flow: id,
      updateRegistrationFlowBody: body,
    });
    return registration.data;
  }
  public async getError(error_id: string): Promise<LibFlowError> {
    const errorReq = await this.oryFrontendApi.getFlowError({ id: error_id });
    return errorReq.data;
  }
  public async checkSession(): Promise<LibSession> {
    const sessionReq = await this.oryFrontendApi.toSession();
    return sessionReq.data;
  }
}
